import { createSelector } from "@reduxjs/toolkit";

const getListTrackingLink = (state) => state.listTrackingLink;

const getIsGetTrackingLinks = (state) => state.isGetTrackingLinks;

const getIsCreateTrackingLinks = (state) => state.isCreateTrackingLinks;

const getIsUpdateTrackingLink = (state) => state.isUpdateTrackingLink;

const getIsRemoveTrackingLink = (state) => state.isRemoveTrackingLink;

const getTotal = (state) => state.total;

export const trackingLinkSelector = createSelector(
  [
    getListTrackingLink,
    getIsGetTrackingLinks,
    getIsCreateTrackingLinks,
    getIsUpdateTrackingLink,
    getIsRemoveTrackingLink,
    getTotal,
  ],
  (
    listTrackingLink,
    isGetTrackingLinks,
    isCreateTrackingLinks,
    isUpdateTrackingLink,
    isRemoveTrackingLink,
    total
  ) => ({
    listTrackingLink,
    isGetTrackingLinks,
    isCreateTrackingLinks,
    isUpdateTrackingLink,
    isRemoveTrackingLink,
    total,
  })
);
